import styled from "styled-components/macro";
import {
  colorGrey,
  colorBackground,
  colorLightGrey,
  colorBorder,
  colorGold,
} from "../../utils/css/colors";
import { ScrollBarStyles } from "../../utils/css/scrollBar";
import { PagePadding } from "../../utils/css/typography";


export const FlexDivColumn = styled.div<{ maxHeight?: string }>`
  display: flex;
  flex-direction: column;
  max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : "300px")};
  overflow-y: auto;
  padding: 4px;
  ${ScrollBarStyles}
`;

export const Divder = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colorGrey};
`;

export const Container = styled.div`
  padding: 1.5rem 3.5rem;
`;

export const FlexDivWitness = styled.div<{
  flexDirection?: string;
  isWrap?: boolean;
  heightDiv?: string;
}>`
  display: flex;
  align-items: baseline;
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : "row"};
  flex-wrap: ${({ isWrap = true }) => isWrap && "wrap"};
  position: relative;
  height: ${(props) => (props.heightDiv ? props.heightDiv : "")};
  width: 100%;
  top: 1rem;
  gap: 10px;
`;

// @ts-ignore
export const TableSectionContainer = styled(PagePadding)<{
  height: number;
  isOpen: boolean;
}>`
  transform: ${(props) =>
    props.isOpen
      ? "translateY(30px)"
      : `translateY(calc(-${props.height}px + ${30}px))}`};
  transition: transform 0.5s ease-in;
`;

export const TableSectionContainerNoPadding = styled.div<{
  height: number;
  isOpen: boolean;
}>`
  transform: ${(props) =>
    props.isOpen
      ? "translateY(30px)"
      : `translateY(calc(-${props.height}px + ${30}px))}`};
  transition: transform 0.5s ease-in;
  height: 0;
`;

export const TableWidthContainer = styled.div`
  width: 720px;
  margin: 0 auto;
`;

export const TableTeamingContainer = styled.div<{ pageHeight: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ pageHeight }) => pageHeight};
  overflow-y: auto;
  ${ScrollBarStyles}
`;

export const TeamingPaddingDiv = styled.div`
  width: 100%;
  padding: 35px 37px 0px 15px;
`;

export const MapClusteredMarkersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  padding: 0 0 0.2rem 0;
  background-color: ${colorBackground};
  opacity: 0.75;
  min-width: 200px;
  max-width: 350px;
  min-height: 60px;
  max-height: 250px;
  border-radius: 6px;
  border: 1px solid ${colorBorder};
  z-index: 100;
  ${ScrollBarStyles};
`;

export const MapClusteredMarkersHeading = styled.h4`
  width: 100%;
  height: 25px;
  padding: 0 0.2rem;
  background-color: ${colorGold};
  font-size: 13px;
`;

export const MapClusteredMarker = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in;
  font-size: 14px;
  padding: 0.4rem 0.5rem 0.4rem 2rem;
  z-index: 100;

  &:hover {
    background-color: ${colorLightGrey};
  }
`;